enum EditMode {
    NONE,
    ADD,
    EDIT
}

export default EditMode;
